import { createReducer } from "@ec-oem/ec.oem.oa3.ui.core/utility";
import { SET_ALL_ANNOUNCEMENT } from "./Announcement.actions";
import { fromJS } from "immutable";

export const allAnnouncementResult = createReducer(null, {
	[SET_ALL_ANNOUNCEMENT](state, { allAnnouncementResult }) {
		return fromJS(allAnnouncementResult);
	}
});
